
        import { createElement as _createElement } from 'react';
import { Fragment as _Fragment } from 'react';
import _map from 'lodash-es/map';
export default function singleVehicleGarageRT () {
    return _createElement('div', { 'className': 'garage-container' }, [this.changeButton(function () {
            return _createElement('div', { 'className': (this.vehicleString ? 'selected' : '') + ' cm_changeButton' }, _createElement('img', {
                'height': '20px',
                'width': '20px',
                'src': 'https://cdn11.bigcommerce.com/s-tkhuby6608/images/stencil/original/image-manager/' + (this.vehicleString ? 'jeep-icon-white' : 'jeep-icon') + '.png'
            }), this.template === 'active' ? _createElement('div', {
                'className': 'active-container cmTemplate_active',
                'key': '297'
            }, 'Add Your Vehicle') : null, this.template === 'locked' ? _createElement('div', {
                'className': 'locked-container cmTemplate_locked',
                'key': '417'
            }, _createElement('span', { 'className': 'model' }, this.vehicleString)) : null);
        }, {
            widgetName: 'undefined',
            items: undefined
        })]);
}
        export const componentNames = ["cm:changeButton"]